// SEE: https://stackoverflow.com/a/43666185/413785
export const truncateFilter = (text: string, length: number, clamp: string = "...") => {
  const node = document.createElement("div");
  node.innerHTML = text;
  const content = node.textContent || "";
  return content.length > length ? content.slice(0, length) + clamp : content;
};